import SuccessIcon from '@/fo/icons/base/icons/check24.svg';
import ErrorIcon from '@/fo/icons/base/icons/close24.svg';

import { styles } from './UiKitToastBase.styles';

export interface UiKitToastBaseProps {
  message: string;
  status: 'success' | 'error';
}

export function UiKitToastBase({ message, status }: UiKitToastBaseProps) {
  const slots = styles({ status });
  return (
    <div className={slots.base()}>
      <div className={slots.icon()}>
        {status === 'success' ? <SuccessIcon /> : <ErrorIcon />}
      </div>
      <div className={slots.message()}>{message}</div>
    </div>
  );
}
